import { createFileRoute } from '@tanstack/react-router'

import { ChatThread, Composer } from '@/components/shared'
import { QUICK_REPLIES, REPLY_TARGET, SPECIALIST, THREAD } from '@/mocks/klient/chat'

/**
 * Replying to something (spec §7.8) — started by swiping a bubble, which is
 * deliberately invisible: no messenger draws a button for it. The state is in
 * the URL so the composer's reply mode is reviewable.
 */
type ChatSearch = { odpoved?: 'prispevek' }

export const Route = createFileRoute('/klient/chat')({
  validateSearch: (search: Record<string, unknown>): ChatSearch =>
    search.odpoved === 'prispevek' ? { odpoved: 'prispevek' } : {},
  head: () => ({ meta: [{ title: 'Chat · Aplikace Bitez' }] }),
  component: KlientChat,
})

function KlientChat() {
  const { odpoved } = Route.useSearch()

  return (
    <div className="flex min-h-full flex-col px-4">
      {/* Floating island: a compact identity pill hovering over the thread —
          messages scroll underneath it, no full-width header bar */}
      <div className="sticky top-2 z-10 flex justify-center pt-2">
        <div className="flex items-center gap-2 rounded-full bg-white py-1.5 pr-3.5 pl-1.5 shadow-lg ring-1 ring-ink/5">
          <span className="relative shrink-0">
            <img
              src={SPECIALIST.avatar}
              alt=""
              width={80}
              height={80}
              className="size-7 rounded-full object-cover"
            />
            <span
              aria-label="Online"
              className="absolute right-0 bottom-0 size-2 rounded-full bg-success ring-1 ring-white"
            />
          </span>
          <span className="min-w-0">
            <span className="font-display block text-sm leading-none uppercase">
              {SPECIALIST.name}
            </span>
            <span className="mt-0.5 block text-[9px] leading-none font-semibold text-ink/45">
              {SPECIALIST.role}
            </span>
          </span>
        </div>
      </div>

      <ChatThread entries={THREAD} avatar={SPECIALIST.avatar} />

      <Composer
        suggestions={QUICK_REPLIES}
        placeholder="Napište zprávu…"
        replyTo={
          odpoved === 'prispevek' ? { ...REPLY_TARGET, cancelHref: '/klient/chat' } : undefined
        }
      />
    </div>
  )
}
